<div class="body">
    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>adb</mat-icon>
        </button>
        <span>
            Datensatz anlegen
        </span>
        <span class="spacer"></span>
        <button mat-icon-button color="warn" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>
    <div class="content">

        <ng-container *ngFor="let entry of typeActionMap">

            <div class="entry" (click)="do(entry.action)">

                <mat-icon class="icon" [style.color]="entry.color">{{entry.icon}}</mat-icon>
                <div class="entry-content">
                    <div class="headline">
                        {{entry.title}}
                    </div>
                    <div class="sub-title">
                        {{entry.subTitle}}
                    </div>
                </div>
            </div>

        </ng-container>
        

    </div>
</div>